<script setup lang="ts">
import { ref, watch } from "vue";
import CloseIcon from "@magnit/icons/src/assets/icons/close-24.svg";
import VText from "../../components/VText/VText.vue";
import VInlineButton from "../../components/VInlineButton/VInlineButton.vue";
import AdBlockIcon from "../../assets/images/ad-block.svg";

const props = defineProps<{
  show: boolean;
}>();

const isShow = ref<boolean>(props.show);

watch(
  () => props.show,
  (next) => (isShow.value = next),
);
</script>

<template>
  <Transition name="unit-yaslot-error-popup">
    <div v-if="isShow" class="unit-yaslot-error-popup">
      <AdBlockIcon />
      <div class="unit-yaslot-error-popup__text">
        <VText tag="div" font="body-large-accent-low" color="invert-primary">
          Блокировщик рекламы скрыл выгодные акции
        </VText>
        <VText tag="div" font="body-small-regular-low" color="invert-primary">
          Если отключите его, сможете видеть все разделы сайта
        </VText>
      </div>
      <div class="unit-yaslot-error-popup__close-button">
        <VInlineButton theme="invert" square @click="isShow = false"
          ><template #icon><CloseIcon /></template
        ></VInlineButton>
      </div>
    </div>
  </Transition>
</template>
<style lang="postcss" scoped>
.unit-yaslot-error-popup {
  display: flex;
  padding: var(--pl-unit-x3);
  background: var(--pl-surface-intense-default);
  position: fixed;
  width: min(calc(100% - 24px), 600px);
  transform: translateX(-50%);
  bottom: 16px;
  left: 50%;
  border-radius: var(--pl-tooltip-radius-m);
  box-shadow: var(--pl-shadow-l);
  z-index: var(--pl-z-index-toast);

  &__text {
    margin: 0 var(--pl-unit-x4);

    > div:first-child {
      margin-bottom: 2px;
    }
  }

  &__close-button {
    position: absolute;
    right: var(--pl-unit-x1);
    top: var(--pl-unit-x1);
  }

  @media (--pl-viewport-from-l) {
    bottom: 32px;
  }
}

/* Transition */
.unit-yaslot-error-popup-enter-active {
  transition: all 0.3s ease-out;
}

.unit-yaslot-error-popup-leave-active {
  transition: all 0.3s ease-in;
}

.unit-yaslot-error-popup-enter-from,
.unit-yaslot-error-popup-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(100%);
}
</style>
